// import gsap from "gsap";

/* global gsap: false */

import CustomSwiper from "../custom-swiper";

const EFFECT_DURATION = 0.5;

export default class HalfSlider {
	constructor(swiper) {
		if (!swiper) return;
		this.swiper = swiper;
		this.cards = swiper.querySelectorAll(".swiper-slide");
		if (0 === this.cards.length) return;
		this.init();
		this.events();
	}

	init() {
		Array.from(this.cards).map((card) => {
			const content = card.querySelector(".content");
			const title = content.querySelector(".title");
			const subtitle = content.querySelector(".subtitle");
			let offset = 0;

			Array.from(content.children).map(
				(child) =>
					(offset +=
						child.offsetHeight +
						parseInt(window.getComputedStyle(child)["margin-bottom"]))
			);

			offset -= title ? title.offsetHeight + ((subtitle && subtitle.offsetHeight) || 0) : 0;
			content.dataset.offset = offset;

			gsap.set(content, {
				y: `${offset}px`,
			});

			gsap.set(content.querySelectorAll(".show-on-hover"), {
				opacity: 0,
			});
		});

		this.swiper = new CustomSwiper(this.swiper);
	}

	mouseEnterHandler(ev) {
		const card = ev.currentTarget;
		const content = card.querySelector(".content");

		gsap.to(content, {
			duration: EFFECT_DURATION,
			y: 0,
		});

		gsap.to(content.querySelectorAll(".show-on-hover"), {
			duration: EFFECT_DURATION,
			opacity: 1,
		});
	}

	mouseLeaveHandler(ev) {
		const card = ev.currentTarget;
		const content = card.querySelector(".content");

		gsap.to(content, {
			duration: EFFECT_DURATION,
			y: `${parseInt(content.dataset.offset)}px`,
		});

		gsap.to(content.querySelectorAll(".show-on-hover"), {
			duration: EFFECT_DURATION,
			opacity: 0,
		});
	}

	events() {
		Array.from(this.cards).map((card) => {
			card.addEventListener("click", this.mouseEnterHandler.bind(this));
			card.addEventListener("mouseenter", this.mouseEnterHandler.bind(this));
			card.addEventListener("mouseleave", this.mouseLeaveHandler.bind(this));
		});
	}
}
